import { render } from "./NewProduct.vue?vue&type=template&id=1f866d87&scoped=true"
import script from "./NewProduct.vue?vue&type=script&lang=js"
export * from "./NewProduct.vue?vue&type=script&lang=js"

import "./NewProduct.vue?vue&type=style&index=0&id=1f866d87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f866d87"]])

export default __exports__